// on importe le controller car les components angularJS
// permettent l'ajout direct d'une fonction dans la propriété "controller"
import ReferentielCaracteristiqueTypeProduitsController from './referentiel.form.caracteristique.type.produits.controller';

export default {
    bindings: {
        // on bind avec '=' (double binding)
        // quand on veut pouvoir modifier l'objet des deux cotés (appelant et component)
        referentiel: '=',
        // on bind avec '<' (binding one way)
        // quand on ne veut pas pouvoir modifier l'objet dans le component (seulement dans l'appelant)
        typeId: '<',
        onUpdate: '&',
        form: '='
    },
    templateUrl:
        'app/common/qualib/referentiels/components/referentiel-form/caracteristique-type-produits/referentiel.form.caracteristique.type.produits.html',
    controller: ReferentielCaracteristiqueTypeProduitsController
    // si on ne déclare pas de 'controllerAs', par défaut ce sera '$ctrl'
};
